import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  computeNextStored,
  extractMarketingParams,
  mergeStoredIntoParams,
  readStoredMarketingParams,
  shallowEqualParams,
  writeStoredMarketingParams
} from './marketingParams';

export const useMarketingParams = (): void => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const incoming = extractMarketingParams(searchParams);
    const stored = readStoredMarketingParams();
    const next = computeNextStored(stored, incoming);
    if (!shallowEqualParams(stored, next)) writeStoredMarketingParams(next);

    const merged = mergeStoredIntoParams(searchParams, next);
    if (merged) setSearchParams(merged, { replace: true });
  }, [searchParams, setSearchParams]);
};
